module.exports = __webpack_public_path__ + "img/music-playlist.8ee310d4.svg";